export const about = {
  'seo.title': 'About Us — Sofia and Elena | Nutritional Science and Cosmetology Experts',
  'seo.description': 'Meet Sofia and Elena — two expert nutritionists working at the intersection of nutritional science and cosmetology. Sofia specializes in child nutrition and vegan nutrition, Elena is an expert in GI tract and hormones.',
  'seo.keywords': 'Sofia nutritionist, Elena nutritionist, child nutrition, hormonal balance, GI tract, metabolism, nutrition experts',

  'hero.title': 'Two experts.\nOne result.',
  'hero.description': 'We\'re not just two friends. We\'re a consilium working at the intersection of nutritional science and cosmetology, so your body sounds beautiful inside and out.',

  'whyTwo.title': 'Why two experts = your result ×10',
  'whyTwo.doubleControl.title': 'Double Control',
  'whyTwo.doubleControl.description': 'While one expert restores your hormonal balance and GI tract function, the other builds your metabolism, works with deficiencies and ensures your skin glows.',
  'whyTwo.deepExpertise.title': 'Deep Expertise',
  'whyTwo.deepExpertise.description': 'You get deep expertise from two sides simultaneously. We don\'t treat symptoms — we rebuild your health "brick by brick".',
  'whyTwo.quote': 'This is not just a consultation. This is a consilium where every detail of your health is examined under the microscope of two professionals.',

  'experts.title': 'Our Superpowers',
  'experts.sofia.name': 'Sofia',
  'experts.sofia.title': 'Nutritionist with cosmetology background',
  'experts.sofia.feature1': 'Expert in child nutrition — knows how to form healthy eating behavior from the cradle',
  'experts.sofia.feature2': 'Works with vegans and athletes — builds nutrition for maximum performance',
  'experts.sofia.feature3': 'Knows how to make your face look 5 years younger while losing weight',
  'experts.sofia.imageAlt': 'Sofia — nutritionist with cosmetology background',
  'experts.elena.name': 'Elena',
  'experts.elena.title': 'Nutritionist expert in GI tract and hormones',
  'experts.elena.feature1': '"Alchemist" of your body — finds the true causes of inflammation and failures',
  'experts.elena.feature2': 'Expert in restoring hormonal balance and gastrointestinal tract function',
  'experts.elena.feature3': 'Works with metabolism and deficiencies at a deep level',
  'experts.elena.imageAlt': 'Elena — nutritionist expert in GI tract and hormones',

  'philosophy.title': 'Chaos in mind = chaos in body',
  'philosophy.belief': 'We don\'t believe in diets. We believe in knowledge.',
  'philosophy.description': 'We teach you to understand your body\'s signals, so that in 2 months you become your own best nutritionist. This is not a temporary diet — it\'s a new lifestyle based on understanding and respect for your body.',
  'philosophy.education.title': 'Education',
  'philosophy.education.description': 'We give you knowledge, not just a meal plan',
  'philosophy.awareness.title': 'Awareness',
  'philosophy.awareness.description': 'We teach you to hear and understand your body\'s signals',
  'philosophy.sustainability.title': 'Sustainability',
  'philosophy.sustainability.description': 'We create habits that will stay with you forever',

  'cta.title': 'Ready to start your journey to yourself?',
  'cta.description': 'Sign up for a free diagnostic, and we\'ll show you how our approach works in practice.',
  'cta.primary': 'Choose Program',
  'cta.secondary': 'Learn More',
  'cta.primaryAria': 'Choose a nutrition program',
  'cta.secondaryAria': 'Learn more about our services',
};